import React from 'react';
import { Scale } from 'lucide-react';

const RIGHTS = [
  'Aftalen er gyldig uden din accept, jf. elforsyningslovens § 72 e.',
  'Du placeres på en reguleret overgangsaftale med et tillæg fastsat af Forsyningstilsynet (§ 72 f) – ens for alle elselskaber og uden månedligt abonnement.',
  'Aftalen er bindende for enkel energi i 3 måneder fra overtagelsen, og du kan opsige med 1 måneds varsel til udgangen af en måned.',
  'Havde du allerede aftalt skift til en anden leverandør, ophører aftalen senest på den planlagte skiftedato.',
  'Du kan vælge at skifte til en anden markedsbaseret elaftale, hvis du ønsker det.',
  'Du kan se dit eget forbrug gratis på eloverblik.dk.',
  'Vil du klage over enkel energi, skal du først kontakte os skriftligt. Hvis vi ikke finder en løsning, kan du klage til Ankenævnet på Energiområdet på energianke.dk.',
];

export default function VelkommenRights() {
  return (
    <section className="py-12 md:py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-3xl mx-auto bg-[#f5f3ee] border border-[#e8e4d9] rounded-2xl p-6 md:p-8">
          <div className="flex items-center gap-3 mb-5">
            <div className="w-10 h-10 bg-[#1a2e1a] rounded-xl flex items-center justify-center flex-shrink-0">
              <Scale className="w-5 h-5 text-[#eab308]" />
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-[#1a2e1a]" style={{ fontFamily: '"Playfair Display", Georgia, serif' }}>
              Dine rettigheder ved tvunget leverandørskift
            </h2>
          </div>
          <ul className="space-y-3">
            {RIGHTS.map((text, i) => (
              <li key={i} className="flex items-start gap-3 text-sm text-gray-700 leading-relaxed">
                <span className="text-[#eab308] font-bold mt-0.5 flex-shrink-0">•</span>
                <span>{text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}